module.exports = __webpack_public_path__ + "static/media/twitter.488cb230.svg";